import React from "react";

const ReadOnlyRow = ({
  isLoadingDelete,
  contact,
  handleEditClick,
  handleDeleteClick,
}) => {
  return (
    <tr className="trrows hover-red bg-white ">
      <td className="bg-gold">{contact.id}</td>
      <td>{contact.farmerid}</td>
      <td>{contact.username}</td>
      <td>{contact.email}</td>
      <td>{contact.password}</td>
      <td>{contact.phone}</td>
         <td style={{ whiteSpace: "nowrap" }}>{contact.joined}</td>
      <td style={{ whiteSpace: "nowrap" }}>{contact.company}</td>

      <td>{contact.lastactive}</td>
      <td>{contact.category}</td>
      <td>{contact.status}</td>

    </tr>
  );
};

export default ReadOnlyRow;
